// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"fdaf5b76","414":"fdaf5b76","418":"fdaf5b76","432":"fdaf5b76","512":"fdaf5b76"}[chunkId] + ".chunk.css";
};